define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Model.extend({
        url: "/rest_about_us/career",

        validation: {
            full_name: {
                required: true
            },
            email: {
                required: true,
                pattern: 'email'
            },
            phone_country: {
                required: true,
                pattern: 'number'
            },
            phone_area: {
                required: true,
                pattern: 'number'
            },
            phone_rest: {
                required: true,
                pattern: 'number'
            },
            resume: {
                required: true
            },
            cover_letter: {
                required: true
            },
            agreement_check: {
                acceptance: true
            }
        },

        labels:{
            full_name: "Full Name",
            email: "Email",
            phone_country: "Phone Number for Country",
            phone_area: "Phone Number for Area",
            phone_rest: "Phone Number",
            resume: "Resume",
            cover_letter: "Cover Letter",
            agreement_check: "Agreement for Upload"
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/models/career_model.js
// module id = 8
// module chunks = 0